export const conexaoTypes = {
	AdicionarConexaoIda: 'ADICIONAR_CONEXAO_IDA',
	AdicionarConexaoVolta: 'ADICIONAR_CONEXAO_VOLTA',
	OrdemViagemIda: 'ORDEM_VIAGEM_IDA',
	OrdemViagemVolta: 'ORDEM_VIAGEM_VOLTA',
	ObterOrdemViagemIda: 'OBTER_ORDEM_VIAGEM_IDA',
	ObterConexao: 'OBTER_CONEXAO',
	ResetConexao: 'RESET_CONEXAO',
}
